import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { buildWebpageColumns } from './columns';
import { getWebpageFields } from './fields';
import { getWebpageSimpleFilters } from './simpleFilters';

/**
 * Webpage QueryEntity - bundles columns and fields
 */
export const webpageEntity: QueryEntity<unknown> = {
  primaryLabel: { actual: 'Webpage', display: 'Web Page' },
  buildColumns:
    buildWebpageColumns as () => import('@/components/table/types').Columns<unknown>,
  getFields: getWebpageFields,
  getSimpleFilters: getWebpageSimpleFilters,
};
